import React from 'react';
import { IAdvantagesData } from '../Advantages/AdvantagesData';
import styled from 'styled-components';

const Advantage = ({ img, subtitle, title }: IAdvantagesData) => {
  return (
    <AdvantageContainer>
      <AdvantageImage src={img} alt="advantage" />
      <AdvantageInfo>
        <AdvantageTitle>{title}</AdvantageTitle>
        <AdvantageSubTitle>{subtitle}</AdvantageSubTitle>
      </AdvantageInfo>
    </AdvantageContainer>
  );
};

const AdvantageContainer = styled.div`
  display: flex;
  width: 45%;
  align-items: flex-start;
  @media (max-width: 1440px) {
    width: 48%;
  }
  @media (max-width: 1135px) {
    width: 46%;
  }
  @media (max-width: 599px) {
    width: 100%;
  }
`;

const AdvantageInfo = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 33px;
  @media (max-width: 1135px) {
    margin-left: 9%;
  }
  @media (max-width: 599px) {
    margin-left: 6%;
  }
`;

const AdvantageImage = styled.img``;

const AdvantageTitle = styled.h4`
  font-weight: 700;
  font-size: 24px;
`;

const AdvantageSubTitle = styled.p`
  font-weight: 400;
  font-size: 20px;
  line-height: 32px;
  margin-top: 0;
`;

export default Advantage;
